import PropTypes from 'prop-types'
import React from 'react'
import { ReactComponent as Happy } from './Happy.svg'
import { ReactComponent as Tired } from './Tired.svg'

const Mascots = ({ className, type }) => {
  let Type
  switch (type) {
    case 'tired':
      Type = Tired
      break
    case 'happy':
      Type = Happy
      break
    default:
      Type = Happy
      break
  }

  return <Type className={className} />
}

Mascots.propTypes = {
  className: PropTypes.string,
  type: PropTypes.oneOf(['tired', 'happy']),
}

export default Mascots
